export const createResourceExplorerThunkFixedCacheKey =
  "create-resource-explorer";
